module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    staticClass: "donate-carousel"
  }, [_c('h2', [_vm._v("Choose design")]), _vm._v(" "), _c('VueSlickCarousel', {
    attrs: {
      "infinite": false
    },
    on: {
      "afterChange": _vm.updateSelectedPackage
    }
  }, _vm._l((_vm.product.packages), function(item) {
    return _c('div', {
      key: item.code,
      staticClass: "slide"
    }, [_c('div', {
      staticClass: "product-pack",
      style: ('background-image: url(' + item.img + ')')
    })])
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17aa62d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=a9gwdhtvlz!./~/string-replace-webpack-plugin/loader.js?id=zp0damlfgbk!./src/components/donation/WildcardCarousel.vue
// module id = 646
// module chunks = 0